import { ThemeProvider } from 'styled-components'
import { main, ThemeType } from './skins/main'
import { GlobalStyles } from './GlobalStyles'
import { DataTableGlobalStyles } from './DataTableGlobalStyles'

declare module 'styled-components' {
  export interface DefaultTheme extends ThemeType { }
}

const themes: any = {
  main,
}

const Component = ({ portal, children }: any) => {
  return (
    <ThemeProvider theme={themes[portal] || main}>
      <GlobalStyles />
      <DataTableGlobalStyles />
      {children}
    </ThemeProvider>
  )
}

export default Component
